import React from "react";
import { IoIosSunny, IoIosPartlySunny, IoIosSnow } from "react-icons/io";

import Typography from "../@typography";
import {
  Column,
  HeaderForm,
  Left,
  Padding,
  Rigth,
  Row,
  RowTemperature,
  Space,
} from "./styles";

interface Props {
  children?: JSX.Element;
  primary: string;
  secondary: string;
  urlImage?: string;
  nameLead?: string;
  emailLead?: string;
  phoneLead?: string;
  flagLead?: string;
  temperature: string;
  produto: string;
}

const HeaderFormComponent: React.FC<Props> = ({
  primary,
  secondary,
  urlImage,
  nameLead,
  emailLead,
  phoneLead,
  temperature,
  produto,
}) => {
  const renderIcon = (temperature: string) => {
    switch (temperature) {
      case "Morno":
        return <IoIosPartlySunny color="white" size={24} />;
      case "Quente":
        return <IoIosSunny color="white" size={24} />;

      case "Frio":
        return <IoIosSnow color="white" size={24} />;
      default:
        return null;
    }
  };

  return (
    <HeaderForm primary={primary} secondary={secondary}>
      <Left>
        <Column>
          <RowTemperature>
            <Padding>{renderIcon(temperature)}</Padding>
            <Typography
              fontSize={16}
              color="white"
              text={temperature || ""}
              variant="subtitle2"
            />
          </RowTemperature>
        </Column>
        <Space />
        <Column>
          <Row>
            <Column style={{ maxWidth: 400 }}>
              <Typography
                fontSize={12}
                color="white"
                text="Nome do lead"
                variant="caption"
              />
              <Typography
                fontSize={16}
                color="white"
                text={nameLead || "--"}
                variant="subtitle2"
              />
            </Column>
            <Column>
              <Typography
                fontSize={12}
                color="white"
                text="Telefone"
                variant="caption"
              />
              <Typography
                fontSize={16}
                color="white"
                text={phoneLead || "--"}
                variant="subtitle2"
              />
            </Column>
            <Column style={{ maxWidth: 280 }}>
              <Typography
                fontSize={12}
                color="white"
                text="E-mail"
                variant="caption"
              />
              <Typography
                fontSize={16}
                color="white"
                text={emailLead || "--"}
                variant="subtitle2"
              />
            </Column>
            <Column>
              <Typography
                fontSize={12}
                color="white"
                text="Produto"
                variant="caption"
              />
              <Typography
                fontSize={16}
                color="white"
                text={produto}
                variant="subtitle2"
              />
            </Column>
          </Row>
        </Column>
      </Left>
      <Rigth>{urlImage && <img src={urlImage} alt="bandeira" />}</Rigth>
    </HeaderForm>
  );
};
export default HeaderFormComponent;
